const TimelineStep = ({ number, title, description, isLast = false }) => (
    <div className="flex-1 relative">
        {/* Connecting Line with Arrow */}
        {!isLast && (
            <div className="hidden md:block absolute w-full h-[2px] bg-orange-200 top-7 left-[50%] z-0">
                {/* Adjusted Arrow to touch the next circle */}
                <div className="absolute left-[87.5%] top-1/2 -translate-y-1/2 transform -translate-x-1/2">
                    <svg 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none"
                    >
                        <path 
                            d="M4 12H20M20 12L14 6M20 12L14 18" 
                            stroke="#fed7aa" /* Same color as bg-orange-200 */
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
        )}

        {/* Step Content */}
        <div className="flex flex-col items-center">
            {/* Number Circle */}
            <div className="w-14 h-14 rounded-full bg-white border-4 border-orange-100 flex items-center justify-center z-10 mb-6 relative">
                <div className="w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center">
                    <span className="text-white font-bold">{number}</span>
                </div>
            </div>

            {/* Text Content */}
            <h3 className="text-xl font-semibold text-zinc-900 mb-3 text-center">{title}</h3>
            <p className="text-zinc-600 text-center text-sm max-w-[250px]">{description}</p>
        </div>
    </div>
);

const HowItWorks = () => {
    const steps = [
        {
            number: "1",
            title: "Join Moinduel",
            description: "Create your profile as a teacher or student and discover AI-powered learning tools"
        },
        {
            number: "2",
            title: "Interactive Learning",
            description: "Experience personalized tutoring with real-time feedback and adaptive content"
        },
        {
            number: "3",
            title: "Measure Success",
            description: "Track progress, analyze performance, and achieve better learning outcomes"
        }
    ];

    return (
        <section className="py-24 relative overflow-hidden">
            <h2 className="text-4xl font-bold text-zinc-900 mb-20 text-center">How it works</h2>
            
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row gap-8 md:gap-0 max-w-4xl mx-auto">
                    {steps.map((step, index) => (
                        <TimelineStep 
                            key={step.number}
                            number={step.number}
                            title={step.title}
                            description={step.description}
                            isLast={index === steps.length - 1}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
